interface FinalCTASectionProps {
  onMarketCTA: () => void;
  onTerritoryCTA: () => void;
}

export default function FinalCTASection({ onMarketCTA, onTerritoryCTA }: FinalCTASectionProps) {
  const metrics = [
    { value: "50", label: "States" },
    { value: "Same Day", label: "Trigger to Call" },
    { value: "91%", label: "Connect rate" },
    { value: "SOC 2", label: "Certified" },
  ];

  return (
    <section className="bg-navy py-16 md:py-28 px-6 lg:px-8 relative overflow-hidden">
      {/* Background decoration */}
      <div
        className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full opacity-5 pointer-events-none"
        style={{ background: "radial-gradient(circle, #19a2fd, transparent)", transform: "translate(30%, -30%)" }}
      />
      <div
        className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-5 pointer-events-none"
        style={{ background: "radial-gradient(circle, #f1663a, transparent)", transform: "translate(-30%, 30%)" }}
      />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Metrics row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-8 pb-8 md:mb-16 md:pb-16 border-b border-white/10">
          {metrics.map((m) => (
            <div key={m.label} className="text-center">
              <p className="text-white text-3xl md:text-4xl font-extrabold">{m.value}</p>
              <p className="text-white/50 text-sm mt-1">{m.label}</p>
            </div>
          ))}
        </div>

        {/* Main CTA */}
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-8">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            <span className="text-white/80 text-xs font-semibold">Markets filling fast</span>
          </div>

          <h2
            className="text-white font-extrabold mb-6"
            style={{ fontSize: "clamp(32px, 4vw, 52px)", lineHeight: "1.1" }}
          >
            Secure Your Market.
            <br />
            <span style={{ color: "#f1663a" }}>Own the Conversation.</span>
            <br />
            Win More Closings.
          </h2>

          <p className="text-white/70 text-lg mb-7 md:mb-10" style={{ lineHeight: "1.65" }}>
            The title companies winning in their markets right now are the ones who got in early.
            Your market might still be available — but it won&apos;t be for long.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <button
              onClick={onMarketCTA}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary text-white font-semibold text-base px-8 py-4 rounded-xl hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-search-line text-base" />
              </span>
              Check Market Availability
            </button>
            <button
              onClick={onTerritoryCTA}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white font-semibold text-base px-8 py-4 rounded-xl hover:border-white/60 hover:bg-white/5 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-award-line text-base" />
              </span>
              Apply for Territory Access
            </button>
          </div>

          <p className="text-white/40 text-sm mt-6">
            No commitment required to check availability. Response within 1 business day.
          </p>
        </div>
      </div>
    </section>
  );
}
